exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table .thead[data-v-fe9507ee] {\n    width: 25%;\n}\n.table-wide[data-v-fe9507ee] {\n    border-top: 0;\n}\n", ""]);

// exports
